import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, PhoneCall, ShieldCheck } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import { useSettings } from "../context/SettingsContext";
import { BrandedForm, FormPhoneLink } from "./BrandedForm";

export const CallbackDrawer = () => {
  const { tc, dir } = useLang();
  const { settings } = useSettings();
  const [open, setOpen] = useState(false);
  const label = tc(settings.callback_label) || "Request a Call";
  const isRTL = dir === "rtl";

  return (
    <>
      {/* Vertical tab */}
      <button
        onClick={() => setOpen(true)}
        data-testid="callback-tab"
        className="fixed bottom-24 sm:bottom-28 z-40 bg-green text-white shadow-[0_10px_30px_rgba(0,0,0,0.3)] hover:bg-green-deep transition-colors"
        style={{
          writingMode: "vertical-rl",
          [isRTL ? "left" : "right"]: 0,
          borderTopLeftRadius: isRTL ? 0 : "14px",
          borderBottomLeftRadius: isRTL ? 0 : "14px",
          borderTopRightRadius: isRTL ? "14px" : 0,
          borderBottomRightRadius: isRTL ? "14px" : 0,
          padding: "18px 10px",
          transform: isRTL ? "rotate(180deg)" : "none",
        }}
        aria-label={label}
      >
        <span className="inline-flex items-center gap-2 font-semibold tracking-wide text-sm">
          <PhoneCall className="w-4 h-4" style={{ transform: "rotate(90deg)" }} />
          {label}
        </span>
      </button>

      <AnimatePresence>
        {open && (
          <>
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={() => setOpen(false)}
              className="fixed inset-0 z-50 bg-black/50"
              data-testid="callback-overlay"
            />
            <motion.aside
              initial={{ x: isRTL ? "-100%" : "100%" }}
              animate={{ x: 0 }}
              exit={{ x: isRTL ? "-100%" : "100%" }}
              transition={{ type: "tween", duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
              className="fixed top-0 end-0 h-full w-[92%] max-w-[460px] bg-[#F7F9F5] z-50 shadow-[0_0_80px_rgba(0,0,0,0.45)] overflow-y-auto"
              data-testid="callback-panel"
            >
              <div className="sticky top-0 z-10 bg-charcoal text-white px-6 py-5 grain">
                <div className="relative flex items-start justify-between gap-4">
                  <div>
                    <span className="text-gold text-[11px] uppercase tracking-[0.28em]">Smart Farmland</span>
                    <h3 className="font-display text-2xl mt-1.5 leading-tight">{label}</h3>
                  </div>
                  <button onClick={() => setOpen(false)} data-testid="callback-close" className="shrink-0 w-9 h-9 rounded-full border border-white/20 hover:bg-white/10 flex items-center justify-center transition-colors">
                    <X className="w-4.5 h-4.5" />
                  </button>
                </div>
                <div className="mt-4 h-px bg-gradient-to-r from-gold via-gold/40 to-transparent" />
              </div>
              <div className="px-6 py-7">
                <BrandedForm />
                <div className="mt-7 pt-6 border-t border-green/10 space-y-4">
                  <FormPhoneLink />
                  <p className="flex items-center justify-center gap-2 text-charcoal/45 text-xs">
                    <ShieldCheck className="w-3.5 h-3.5 text-green-light" />
                    {tc({ tr: "Bilgileriniz gizli tutulur, üçüncü taraflarla paylaşılmaz.", en: "Your details stay confidential and are never shared.", ar: "تبقى بياناتك سرية ولا تُشارك مع أي جهة." })}
                  </p>
                </div>
              </div>
            </motion.aside>
          </>
        )}
      </AnimatePresence>
    </>
  );
};
